import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  AuthCallbackView,
  AuthRenewView,
  Unity4Claim,
  AuthGuard,
  ClaimGuard,
} from '@adreno-common';
import { NotFoundComponent } from '@adreno-common';
import { CoreComponent } from './core/components';

const routes: Routes = [
  {
    path: 'callback',
    component: AuthCallbackView,
  },
  {
    path: 'silent-renew',
    component: AuthRenewView,
  },
  {
    path: '',
    component: CoreComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'news',
        data: {
          claim: Unity4Claim.NewsModule,
        },
        loadChildren: () =>
          import('./news/news.module').then((m) => m.NewsModule),
      },
      {
        path: 'contact-details',
        data: {
          claim: Unity4Claim.WorkModule,
        },
        loadChildren: () =>
          import('./user-contact/user-contact.module').then(
            (m) => m.UserContactModule
          ),
      },
      {
        path: 'work',
        data: {
          claim: Unity4Claim.WorkModule,
        },
        loadChildren: () =>
          import('./work/work.module').then((m) => m.WorkModule),
      },
      {
        path: 'availability',
        data: {
          claim: Unity4Claim.WorkViaAvailabilityModule,
        },
        loadChildren: () =>
          import('./availability/availability.module').then(
            (m) => m.AvailabilityModule
          ),
      },
      {
        path: 'training',
        data: {
          claim: Unity4Claim.TrainingModule,
        },
        loadChildren: () =>
          import('./training/training.module').then((m) => m.TrainingModule),
      },
      {
        path: 'timesheets',
        data: {
          claim: Unity4Claim.TimesheetsModule,
        },
        loadChildren: () =>
          import('./timesheets/timesheets.module').then(
            (m) => m.TimesheetsModule
          ),
      },
      {
        path: 'reports',
        data: {
          claim: Unity4Claim.AgentReportsModule,
        },
        loadChildren: () =>
          import('./reports/reports.module').then((m) => m.ReportsModule),
      },
      {
        path: 'testing',
        data: {
          claim: Unity4Claim.TestingModule,
        },
        canActivate: [ClaimGuard],
        loadChildren: () =>
          import('./testing/testing.module').then((m) => m.TestingModule),
      },
      {
        path: '',
        redirectTo: '/news',
        pathMatch: 'full',
      },
      {
        path: '**',
        component: NotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
